import { App } from 'antd'
import { antdStaticApi } from './antd-static-api'

/**
 * Renders nothing — its only job is to call App.useApp()
 * and store the result so non-component code can use
 * context-aware modal / message / notification APIs.
 *
 * Must be rendered as a child of <App> from antd.
 */
export const AntdStaticApiProvider: React.FC = () => {
    const { modal, message, notification } = App.useApp()
    antdStaticApi.modal = modal
    antdStaticApi.message = message
    antdStaticApi.notification = notification
    return null
}
